<template>
  <div class="text-sm">
    <p class="mt-6"><b>2026.02.17</b> - *FINALLY* Caverns is done leaking (probably)</p>
    <div class="ml-5 pb-4 text-violet-300">
      <div class="font-bold mt-2">Performance</div>
      <ul class="ml-4 list-disc">
        <li>
          Fixed multiple memory leaks in Caverns, including display objects, AI pathfinding, unit
          conditions, battle log entries, and more!
        </li>
        <li>Switched to bitmap fonts (less CPU) for floating text.</li>
      </ul>

      <div class="font-bold mt-2">QoL</div>
      <ul class="ml-4 list-disc">
        <li>
          Equipment slots now have backgrounds and tooltips when empty, indicating what type of gear
          belongs in each slot.
        </li>
        <li>Hero stat bars in Caverns now animate when losing HP or spending AP/MP.</li>
      </ul>

      <div class="font-bold mt-2">Bug Fixes</div>
      <ul class="ml-4 list-disc">
        <li>
          Candles now properly expire when logging in or leaving battle screens, and expired candles
          are no longer rendered in the Temple.
        </li>
      </ul>
    </div>
  </div>
</template>
